document.addEventListener('DOMContentLoaded', function() {
  // Einfache Funktion, die alle 100ms prüft und die aktiven Tabs synchronisiert
  function initProductSliderTabs() {
    // Diese Funktion wird regelmäßig ausgeführt
    function syncActiveThumbs() {
      // Alle Wrapper durchgehen
      document.querySelectorAll('.pst__wrapper').forEach(wrapper => {
        // Den aktiven Slide finden
        const activeSlide = wrapper.querySelector('.css-slide-active');
        if (!activeSlide) return;
        
        // Den Index des aktiven Slides bekommen (0-basiert)
        const slideIndex = activeSlide.getAttribute('data-index');
        if (slideIndex === null) return;
        
        // Umrechnen auf 1-basierten Index für die Tabs
        const thumbIndex = parseInt(slideIndex) + 1;
        
        // Alle Thumbs durchgehen und die richtige Klasse setzen
        wrapper.querySelectorAll('.pst__item-thumbs').forEach(thumb => {
          const thumbIdx = thumb.getAttribute('pst__item-thumbs-index');
          
          if (thumbIdx === thumbIndex.toString()) {
            // Klasse nur hinzufügen, wenn sie noch nicht da ist
            if (!thumb.classList.contains('color-background-active')) {
              thumb.classList.add('color-background-active');
            }
          } else {
            // Klasse nur entfernen, wenn sie da ist
            if (thumb.classList.contains('color-background-active')) {
              thumb.classList.remove('color-background-active');
            }
          }
        });
      });
    }
    
    // Beim Klick auf einen Thumb den entsprechenden Slide aktivieren
    document.querySelectorAll('.pst__item-thumbs').forEach(thumb => {
      thumb.addEventListener('click', function() {
        const wrapper = this.closest('.pst__wrapper');
        if (!wrapper) return;
        
        const index = this.getAttribute('pst__item-thumbs-index');
        if (!index) return;
        
        // 0-basierten Index für den Slider berechnen
        const slideIndex = parseInt(index) - 1;
        
        // Den entsprechenden Dot im Slider finden und klicken
        const slider = wrapper.querySelector('.css-slider');
        if (slider) {
          const dot = slider.querySelector(`.css-slider-dot[data-index="${slideIndex}"]`);
          if (dot) {
            dot.click();
          }
        }
      });
    });
    
    // Erste Synchronisierung direkt durchführen
    syncActiveThumbs();
    
    // Dann regelmäßig alle 200ms prüfen (wichtig für Animation und Initialzustand)
    setInterval(syncActiveThumbs, 200);
  }
  
  // Initialisierung starten
  initProductSliderTabs();
  
  // Falls im Shopify Theme Editor, neu initialisieren, wenn Abschnitte geladen werden
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      initProductSliderTabs();
    });
  }
});